import axios from 'axios'
import { ax_get_fpool_fastquote } from 'src/types'
import { v4 } from 'uuid'

import { axios_request, configify, POST, VERSION_V1 } from './base.axios'

const BASE_URL = process.env.REACT_APP_BASE_URL_FAST_QUOTE || ''

/**
 * Fast Quote client
 */
export const fastquote_client = axios.create(configify({ base_url: BASE_URL }))

/**
 * GET fpool fastquote
 */
export const get_fpool_fastquote = ({
  language,
  ...data
}: ax_get_fpool_fastquote): axios_request => ({
  url: `/${VERSION_V1}/fastquote`,
  method: POST,
  headers: {
    requestId: v4(),
    captcha: 'captcha',
    language,
  },
  data,
})
